/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Hard_EbInputs */

const en_funnel_ob_ben_hard_eb = /** @type {(inputs: Funnel_Ob_Ben_Hard_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You said reading is hard`)
};

const es_funnel_ob_ben_hard_eb = /** @type {(inputs: Funnel_Ob_Ben_Hard_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dijiste que leer te cuesta`)
};

/**
* | output |
* | --- |
* | "You said reading is hard" |
*
* @param {Funnel_Ob_Ben_Hard_EbInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_hard_eb = /** @type {((inputs?: Funnel_Ob_Ben_Hard_EbInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Hard_EbInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_hard_eb(inputs)
	return en_funnel_ob_ben_hard_eb(inputs)
});